const NetWatch = ({ AddressIp, ActiveNetWatch, InfoZona, idForMikrotik, Nombres, idCliente, idServicio, idNetWatch })=>{
    return new Promise((resolve, reject)=>{
        const infoUp_ = `:local botTelegramToken "5422498643:AAHqlgu7S4GffyRqQ2x1R7D2XD0ajBed0e4";\n
        :local telegramChatID "891511682";\n
        :local parseMode "html";\n
        :local disablePreview True;\n
        :local textToSend "CLIENTE: ${idForMikrotik} || ${Nombres} LEVANTADO"; \n
    
        :local telegramUrl "https://api.telegram.org/bot$botTelegramToken/sendMessage?chat_id=$telegramChatID&text=$textToSend&parse_mode=$parseMode&disable_web_page_preview=$disablePreview";\n
    
        /tool fetch http-method=get url=$telegramUrl;\n
    
        :log info "Send Telegram Message";
        `;
    
        const infoDown_ = `:local botTelegramToken "5422498643:AAHqlgu7S4GffyRqQ2x1R7D2XD0ajBed0e4";\n
        :local telegramChatID "891511682";\n
        :local parseMode "html";\n
        :local disablePreview True;\n
        :local textToSend "CLIENTE: ${idForMikrotik} || ${Nombres} CAIDO";\n
    
        :local telegramUrl "https://api.telegram.org/bot$botTelegramToken/sendMessage?chat_id=$telegramChatID&text=$textToSend&parse_mode=$parseMode&disable_web_page_preview=$disablePreview";\n
    
        /tool fetch http-method=get url=$telegramUrl;\n
    
        :log info "Send Telegram Message";\n
        `;
        
        if(ActiveNetWatch){
            fetch('/api/OptionNetWatch',{
                method:'POST',
                body: JSON.stringify({
                    idCliente:idCliente,
                    idServicio:idServicio,
                    AddressIp:AddressIp, 
                    InfoZona:InfoZona, 
                    ActiveNetWatch:ActiveNetWatch,
                    infoUp:infoUp_,
                    infoDown:infoDown_,
                    Comentario:` ${idForMikrotik} || ${Nombres} `
                }),
                headers:{'Content-Type': 'application/json'}
            }) 
            .then(response=> response.json())
            .then((result) =>{
                if(result.message){
                    resolve({
                        isCreate:true,
                        idNetWatch:result.message
                    });
                }else{
                    reject({
                        isCreate:false,
                        reason:result.status
                    });
                }
            });
        }else{
            fetch('/api/OptionNetWatch',{
                method:'DELETE',
                body: JSON.stringify({
                    idCliente:idCliente,
                    idServicio:idServicio,
                    idNetWatch:idNetWatch,
                    ActiveNetWatch:ActiveNetWatch,
                    InfoZona:InfoZona, 
                }),
                headers:{'Content-Type': 'application/json'}
            }) 
            .then(response=> response.json())
            .then((result) =>{
                if(result.message){
                    resolve({
                        isCreate:true,
                        idNetWatch:''
                    });
                }else{
                    reject(
                        {isCreate:false,
                            reason:result.status}
                    );
                }
            });
        }
        
        


    });
    
};

export default NetWatch;